import pSBC from '../../vendor/pSBC';

export default function(schemeOptions, height) {
  if (height === undefined) {
    height = '24px';
  }

  schemeOptions = schemeOptions || {};
  let scheme = {
    schemeSysBackground: schemeOptions.sysBackground || '#272822',
    schemeBackground: schemeOptions.background || '#2b91e6',
    schemeForeground: schemeOptions.foreground || '#ffffff',
    schemeFontSize: schemeOptions.fontSize || '12px',
    schemeFontWeight: schemeOptions.fontWeight || 'normal',
    schemeAnimationDuration: schemeOptions.animationDuration || '0.3s',
    height,
  };
  scheme.schemeShade = pSBC(-0.8, scheme.schemeBackground);
  scheme.schemeSysShade = pSBC(-0.8, scheme.schemeSysBackground);
  scheme.schemeBackgroundHover = pSBC(-0.25, scheme.schemeBackground);
  scheme.schemeForegroundHover = pSBC(0.25, scheme.schemeForeground);
  height = height || scheme.schemeFontSize + ' * 2';
  scheme.schemePaddingTop = `calc((${height} - ${scheme.schemeFontSize}) / 2)`;
  return scheme;
}
